var ezdia;
(function (ezdia) {
    var colListItem = function (context) {
        var e_1, _a;
        var htmlContent = [];
        var count = 0;
        try {
            for (var context_1 = __values(context), context_1_1 = context_1.next(); !context_1_1.done; context_1_1 = context_1.next()) {
                var col = context_1_1.value;
                var _b = col, label = _b.label, edittype = _b.edittype, name_1 = _b.name, hidden = _b.hidden;
                var isGridColumnHidden = ezdia.util.isGridColumnHidden(col);
                if (!label ||
                    isGridColumnHidden ||
                    edittype === 'multiple' ||
                    edittype === 'menu') {
                    if (label) {
                        htmlContent.push("<input hidden data-column=\"choose\" type=\"checkbox\" name=\"" + name_1 + "\" value=\"" + label + "\" " + (!hidden ? 'checked' : '') + ">");
                    }
                }
                else {
                    htmlContent.push("<li class=\"checkbox\" data-list=\"search\" data-index=\"" + count + "\">\n          <label data-name=\"" + name_1 + "\">\n            <input data-column=\"choose\" type=\"checkbox\" name=\"" + name_1 + "\" value=\"" + label + "\" " + (!hidden ? 'checked' : '') + ">" + label + "\n          </label>\n        </li>");
                }
                count += 1;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (context_1_1 && !context_1_1.done && (_a = context_1.return)) _a.call(context_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return htmlContent.join('');
    };
    var itemTemplate = function (context) {
        var colList = context.colList, id = context.id, searchId = context.searchId, selectAll = context.selectAll;
        var ret = "<div class=\"grid-column-chooser-list\">\n      <ul id=\"" + id + "\" data-search-container=\"" + searchId + "\" class=\"list-unstyled\">\n        <li id=\"selectAll\" class=\"checkbox select-all\" data-list=\"search\">\n          <label data-name=\"all\">\n            <input data-column=\"choose\" type=\"checkbox\" id=\"chooseAllColumn\" name=\"all\" value=\"Select All\" " + (selectAll ? 'checked' : '') + ">Select All\n          </label>\n        </li>\n        " + colListItem(colList) + "\n        <li style=\"display: none\" id=\"noresult\" class=\"warning\">Search query not found.</li>\n      </ul>\n    </div>";
        return ret;
    };
    var popoverList = function (context) {
        var popoverId = context.popoverId, id = context.id, btnLabel = context.btnLabel, buttons = context.buttons;
        var ret = "<div class=\"popover grid-choose-columns-popover\" id=\"" + popoverId + "\">\n      <div class=\"arrow\"></div>\n      <div class=\"popover-search\"><input type=\"text\" class=\"form-control\" id=\"" + id + "\" placeholder=\"Filter\"></div>\n      <div class=\"popover-content\"></div>\n      <div class=\"popover-btn btn-group\" data-container=\"buttons\">\n        " + (buttons
            ? buttons
                .map(function (btns) {
                return "<button type=\"button\" class=\"btn btn-default\">" + btns.btns.label + "</button>";
            })
                .join('')
            : '') + "\n        <button type=\"button\" class=\"btn btn-default\" data-btn=\"done\">" + btnLabel + "</button>\n      </div>\n    </div>";
        return ret;
    };
    var templates;
    (function (templates) {
        templates.popupList = {
            itemTemplate: itemTemplate,
            popoverList: popoverList
        };
    })(templates = ezdia.templates || (ezdia.templates = {}));
})(ezdia || (ezdia = {}));
